import React, { SVGProps } from 'react';

const MockTrading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="MockTrading">
    <path
      d="M3.333 2.167v9.166h13.334V2.167H3.333Zm-1.666-.828c0-.463.379-.839.827-.839h15.013c.456 0 .826.374.826.84V13H1.668V1.34ZM.833 13.833h18.334V15.5H.833v-1.667Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default MockTrading;
